import { createTranslations } from '@/i18n/types';

const translations = createTranslations({
  en: { unlocked: 'Achievement unlocked!', xp: 'XP', claimReward: 'Claim reward', locked: 'Reward locked' },
  ru: { unlocked: 'Ачивка получена!', xp: 'XP', claimReward: 'Забери награду', locked: 'Награда заблокирована' },
  uz: { unlocked: 'Yutuq ochildi!', xp: 'XP', claimReward: 'Mukofotni oling', locked: 'Mukofot bloklangan' },
});

export default translations;
